import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { TokenService } from '@shared/services/token.service';

export const authenticatedGuard: CanActivateFn = (route, state) => {
  const tokenService: TokenService = inject(TokenService);
  const router: Router = inject(Router);
  if (tokenService.getToken() === null) {
    router.navigate(['/login']);
    return false;
  }
  return true;
};
